import get from "lodash/get"

const styles = theme => ({
    root: {
        display: "none",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1,
        flexWrap: "wrap",
        flexDirection: "column",
        padding: `0 ${theme.spacing()}px`,
        color: get(theme, "palette.primary.dark"),
        backgroundColor: get(theme, "appicalTheme.mainBg"),

        "&$loading": {
            display: "flex",
        },

        "&$transparent": {
            backgroundColor: "transparent",
        },
    },

    primary: {
        color: get(theme, "palette.primary.dark"),
    },

    secondary: {
        color: get(theme, "palette.secondary.dark"),
    },

    textPrimary: {
        color: get(theme, "palette.primary.contrastText"),
    },

    textSecondary: {
        color: get(theme, "palette.secondary.contrastText"),
    },

    loading: {},
    transparent: {},
    background: {},

    appicalLogo: {
        textAlign: "center",
        marginBottom: "32px",
    },

    loader: {
        width: "100%",
        maxWidth: "350px",
    },
})

export default styles
